export const transactionUpdated = "event.socket.transaction.updated";

export const roundStockUpdated = "event.socket.round.stock.updated";
